import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {withShade} from '@dropbox/dig-foundations';
import {Avatar} from 'components/DSYS/Avatar';
import {LabelGroup} from 'components/DSYS/LabelGroup';
import {NewArrivalItem} from 'views/home/dashboard/dashboardModel';
import {TileListRow} from 'views/home/dashboard/TileListRow';

export const NewArrivalPersonRow = ({
  item,
  shade,
}: {
  item: NewArrivalItem;
  shade: ReturnType<typeof withShade>;
}) => (
  <TileListRow shade={shade}>
    <LabelGroup
      align="top"
      withLeftAccessory={
        <Avatar
          size="small"
          user={
            {
              name: item.name,
              ldap: item.ldap,
              profile_photo_url: item.photoUrl,
            } as never
          }
        />
      }
      withText={
        <Text isBold tagName="div" style={{minWidth: 0}}>
          <Truncate observeParent>{item.name}</Truncate>
        </Text>
      }
      withSubtext={
        <Text size="small" color="faint" tagName="div" style={{minWidth: 0}}>
          <Truncate observeParent>{item.detail}</Truncate>
        </Text>
      }
    />
  </TileListRow>
);
